import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('/abilities', { params: params })
      .then(response => response.data)
  }
}
